import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: string;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconGuestlist = ({ id, color, width = 43, style, ...restProps }: IProps) => {
  const viewBoxWidth = 43;
  const viewBoxHeight = 50;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons-HUB" transform="translate(-571.000000, -152.000000)">
          <g id="ico-guestlist-copy" transform="translate(571.000000, 152.000000)">
            <path
              d="M29.6161544,23.611393 C27.1264209,23.611393 24.6804978,22.7684423 22.7295385,21.2372363 C21.8207065,20.5230441 21.6659721,19.2123021 22.3837163,18.3091407 C23.1014605,17.4059793 24.4213641,17.2522103 25.3292639,17.9654762 C26.5606147,18.9316274 28.0436421,19.4429557 29.6161544,19.4429557 C33.4323164,19.4429557 36.5372593,16.3573857 36.5372593,12.5641078 C36.5372593,8.77175618 33.4323164,5.68618626 29.6161544,5.68618626 C28.1023666,5.68618626 26.665946,6.16324075 25.460695,7.06454953 C24.5350846,7.75651012 23.2207738,7.57217256 22.5235366,6.65141108 C21.8272315,5.73250223 22.0127264,4.42546556 22.9383368,3.73350497 C24.8762462,2.28474143 27.1860775,1.51774897 29.6161544,1.51774897 C35.7458763,1.51774897 40.7318683,6.47355775 40.7318683,12.5641078 C40.7318683,18.6555842 35.7458763,23.611393 29.6161544,23.611393"
              id="Fill-9"
              fill={color}
            />
            <path
              d="M40.2278627,45.7733993 C39.0692185,45.7733993 38.1305582,44.8396694 38.1305582,43.6891807 L38.1305582,38.7926563 C38.1305582,34.6112506 34.7077572,31.2088794 30.4991662,31.2088794 L28.7327697,31.2088794 C27.1770358,31.2088794 25.6781622,31.6766707 24.3983404,32.562232 C23.4475623,33.2199188 22.1397765,32.9874127 21.4788925,32.0425669 C20.8170764,31.0977211 21.0510424,29.7990213 22.0018204,29.1413345 C23.989133,27.7676028 26.3166749,27.0404421 28.7327697,27.0404421 L30.4991662,27.0404421 C37.020385,27.0404421 42.3251672,32.3130521 42.3251672,38.7926563 L42.3251672,43.6891807 C42.3251672,44.8396694 41.3865069,45.7733993 40.2278627,45.7733993"
              id="Fill-11"
              fill={color}
            />
            <path
              d="M15.0041872,4.34135576 C10.3640175,4.34135576 6.58980154,8.09202301 6.58980154,12.7023147 C6.58980154,17.3135326 10.3640175,21.0651262 15.0041872,21.0651262 C19.644357,21.0651262 23.4185729,17.3135326 23.4185729,12.7023147 C23.4185729,8.09202301 19.644357,4.34135576 15.0041872,4.34135576 M15.0041872,25.2335635 C8.05232189,25.2335635 2.39519252,19.6117311 2.39519252,12.7023147 C2.39519252,5.79382458 8.05232189,0.172918461 15.0041872,0.172918461 C21.9560526,0.172918461 27.613182,5.79382458 27.613182,12.7023147 C27.613182,19.6117311 21.9560526,25.2335635 15.0041872,25.2335635"
              id="Fill-13"
              fill={color}
            />
            <path
              d="M27.372225,49.3185163 C26.2135807,49.3185163 25.2749205,48.3847863 25.2749205,47.2342976 L25.2749205,42.2590362 C25.2749205,36.6307195 20.6673755,32.0509964 15.0037212,32.0509964 C9.34099899,32.0509964 4.73345402,36.6307195 4.73345402,42.2590362 L4.73345402,47.2342976 C4.73345402,48.3847863 3.79479373,49.3185163 2.63614951,49.3185163 C1.47750528,49.3185163 0.538844998,48.3847863 0.538844998,47.2342976 L0.538844998,42.2590362 C0.538844998,34.3315947 7.02743908,27.8825591 15.0037212,27.8825591 C22.9809354,27.8825591 29.4695295,34.3315947 29.4695295,42.2590362 L29.4695295,47.2342976 C29.4695295,48.3847863 28.5308692,49.3185163 27.372225,49.3185163"
              id="Fill-15"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconGuestlist;
